export default __webpack_public_path__ + "static/media/placeholder_business04-it-web.378ec899.png";